var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "clearfix main_center" }, [
    _c(
      "div",
      { staticClass: "content clearfix" },
      [
        _vm.customFormShow
          ? _c("customForm", {
              ref: "customFormRef",
              attrs: {
                auditHisTable: _vm.auditHisTable,
                entityId: _vm.entityId,
                nodeCode: _vm.nodeCode,
                categoryCode: _vm.categoryCode,
                baseURL: _vm.baseURL,
              },
              on: {
                "update:auditHisTable": function ($event) {
                  _vm.auditHisTable = $event
                },
                "update:audit-his-table": function ($event) {
                  _vm.auditHisTable = $event
                },
                "update:entityId": function ($event) {
                  _vm.entityId = $event
                },
                "update:entity-id": function ($event) {
                  _vm.entityId = $event
                },
                "update:nodeCode": function ($event) {
                  _vm.nodeCode = $event
                },
                "update:node-code": function ($event) {
                  _vm.nodeCode = $event
                },
                "update:categoryCode": function ($event) {
                  _vm.categoryCode = $event
                },
                "update:category-code": function ($event) {
                  _vm.categoryCode = $event
                },
                "update:baseURL": function ($event) {
                  _vm.baseURL = $event
                },
                "update:base-u-r-l": function ($event) {
                  _vm.baseURL = $event
                },
              },
            })
          : _vm._e(),
        _vm.customFormOtherShow
          ? _c("customFormOther", {
              ref: "customFormOtherRef",
              attrs: {
                auditHisTable: _vm.auditHisTable,
                entityId: _vm.entityId,
                categoryCode: _vm.categoryCode,
                nodeCode: _vm.nodeCode,
                purchaserMode: _vm.purchaserMode,
              },
              on: {
                "update:auditHisTable": function ($event) {
                  _vm.auditHisTable = $event
                },
                "update:audit-his-table": function ($event) {
                  _vm.auditHisTable = $event
                },
                "update:entityId": function ($event) {
                  _vm.entityId = $event
                },
                "update:entity-id": function ($event) {
                  _vm.entityId = $event
                },
                "update:categoryCode": function ($event) {
                  _vm.categoryCode = $event
                },
                "update:category-code": function ($event) {
                  _vm.categoryCode = $event
                },
                "update:nodeCode": function ($event) {
                  _vm.nodeCode = $event
                },
                "update:node-code": function ($event) {
                  _vm.nodeCode = $event
                },
                "update:purchaserMode": function ($event) {
                  _vm.purchaserMode = $event
                },
                "update:purchaser-mode": function ($event) {
                  _vm.purchaserMode = $event
                },
              },
            })
          : _vm._e(),
        !_vm.customFormShow && !_vm.customFormOtherShow
          ? _c(
              "el-card",
              {
                staticClass: "box-card",
                staticStyle: {
                  height: "700px",
                  position: "relative",
                  "margin-bottom": "10px",
                },
              },
              [
                _vm.groupList.length == 0
                  ? _c("emptyInfo", { attrs: { emptyMsg: "暂无表单数据" } })
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }